const e={PAGE:"page",LINK:"direct",EMAIL:"email"},l=[{value:e.PAGE,label:"Confluence page"},{value:e.LINK,label:"Direct link"},{value:e.EMAIL,label:"Email address"}];export{e as LINK_TYPES,l as SOURCES_OPTIONS};
